export default __webpack_public_path__ + "static/media/IMG_5330.66fe4e9c.PNG";